import script from "./Error.vue?vue&type=script&setup=true&lang=ts"
export * from "./Error.vue?vue&type=script&setup=true&lang=ts"

import "./Error.vue?vue&type=style&index=0&id=c8624426&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8624426"]])

export default __exports__